import * as helpers from 'helpers';
import { formatMoney } from 'helpers';
import { createContext, useContext, useMemo } from 'react';
import * as setup from 'setup';

const defaultData = {
    footer: setup.footer,
    game: setup.game,
    general: setup.general,
    header: setup.header,
    landing: setup.landing,
    lessons: setup.lessons,
};

const ContentContext = createContext<ContentState>({} as ContentState);

export const useContent = () => useContext(ContentContext);

export function withContent(WrappedComponent: any) {
    return function ContentWrappedComponent(props: any) {
        return (
            <ContentContext.Consumer>
                {state => <WrappedComponent {...props} content={state} />}
            </ContentContext.Consumer>
        );
    };
}

export function ContentProvider({ children }: ContentProviderProps) {
    const setupVariables = useMemo(() => {
        return {
            allInCost: formatMoney(setup.cards.allInCost),
            cardValueMultiplier: setup.cards.valueMultiplier,
            communityCost: formatMoney(setup.cards.communityCost),
            flopCost: formatMoney(setup.cards.flopCost),
            flopRemainingCosts: formatMoney(setup.cards.flopRemainingCosts),
            holeCost: formatMoney(setup.cards.holeCost),
            holeRemainingCosts: formatMoney(setup.cards.holeRemainingCosts),
            largeBudget: formatMoney(setup.cards.largeBudget),
            riverCost: formatMoney(setup.cards.riverCost),
            riverRemainingCosts: formatMoney(setup.cards.riverRemainingCosts),
            smallBudget: formatMoney(setup.cards.smallBudget),
            spyOpponentCost: formatMoney(setup.cards.spyOpponentCost),
            turnCost: formatMoney(setup.cards.turnCost),
            turnRemainingCosts: formatMoney(setup.cards.turnRemainingCosts),
        };
    }, []);

    function parseHtml(html: string, variables?: Variables) {
        // Merge variables
        const vars = {
            ...setupVariables,
            ...variables,
        };

        // Parse HTML
        const parsed = helpers.parseHtml(html, vars);
        if (parsed.includes('{')) {
            return helpers.parseHtml(parsed, vars);
        }
        return parsed;
    }

    const state = {
        ...defaultData,
        parseHtml,
        reload: () => undefined,
    };

    return (
        <ContentContext.Provider value={state}>{children}</ContentContext.Provider>
    );
}
